import { render, staticRenderFns } from "./pop-nutritional.vue?vue&type=template&id=819768e6&scoped=true"
import script from "./pop-nutritional.vue?vue&type=script&lang=js"
export * from "./pop-nutritional.vue?vue&type=script&lang=js"
import style0 from "./pop-nutritional.vue?vue&type=style&index=0&id=819768e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819768e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819768e6')) {
      api.createRecord('819768e6', component.options)
    } else {
      api.reload('819768e6', component.options)
    }
    module.hot.accept("./pop-nutritional.vue?vue&type=template&id=819768e6&scoped=true", function () {
      api.rerender('819768e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore/components/pop-nutritional.vue"
export default component.exports